/**
* Book Now CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Book Now CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'book-now-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
        llParallax();
        const llParallaxDebounce = new app.components.common.Debounce( llParallax, 250 );
        $( window ).on( 'resize', function() {
          llParallaxDebounce.run();
        } );
      }
      function llParallax() {
        $( '.ll-parallax-up' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top+=25% bottom',
              end: 'bottom top',
              pin: false,
              // markers: true,
              scrub: 1,
              delay: 0.25,
            },
          } );
          tl.fromTo( $( this ), {yPercent: 50}, {yPercent: 0} );
        } );
        $( '.ll-parallax-middle' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top+=76px bottom+=100%',
              end: 'bottom top',
              pin: false,
              // markers: true,
              scrub: 1,
              delay: 0.25,
            },
          } );
          tl.fromTo( $( this ), {yPercent: 50}, {yPercent: 0} );
        } );
        $( '.ll-parallax-down' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top+=76px bottom',
              end: 'bottom top+=0px',
              pin: false,
              // markers: true,
              scrub: 1,
              delay: 0.25,
            },
          } );
          tl.fromTo( $( this ), {yPercent: 0}, {yPercent: 16} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'book-now-cta', COMPONENT );
} )( app );
